/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReactJson from 'react-json-view';
import {
  Descriptions,
  Card,
  Table, Modal,
} from 'antd';

import { getTimelineById, getTimeLines } from '../../redux/actions/TimeLine';
import { columns } from './index';
import generateQuery from '../../util/table';
import TimelimeDetailsForModal from './TimelineDetailsForModal';

const TimelineDetails = () => {
  const dispatch = useDispatch();
  const { timelineId } = useParams();
  const { timeline_logs, timeline_log: { data } } = useSelector(({ timeline_log }) => timeline_log);

  useEffect(() => {
    if (timelineId) {
      dispatch(getTimelineById(timelineId));
    }
  }, [dispatch, timelineId]);

  useEffect(() => {
    if (data?.kitegateway_reference) {
      const searchParams = JSON.stringify([{ kitegateway_reference: { $regex: data.kitegateway_reference, $options: 'i' } }]);
      const search = `filter={"$or": ${searchParams}}`;
      dispatch(getTimeLines(search));
    }
  }, [dispatch, data]);

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [visibleTransactionModal, setVisibilityTransactionModal] = useState({});

  const dataSource = timeline_logs.data.length && timeline_logs.data.map(({
    _id,
    kitegateway_reference,
    server_name,
    stage,
    status,
    status_message,
    callback_url,
    callback_payload,
    callback_response_code,
    created_at,
    updated_at,
  }) => ({
    key: _id,
    kitegateway_reference,
    server_name,
    stage,
    status,
    status_message,
    callback_url,
    callback_payload,
    callback_response_code,
    created_at,
    updated_at,
  }));

  const viewTransactionDetails = (record) => ({
    onClick: () => {
      setSelectedRecord(record);
      setVisibilityTransactionModal(true);
    },
  });

  const handleModalCancelTransactionModal = () => {
    setVisibilityTransactionModal(false);
    setSelectedRecord(null);
  };

  const handleOnChange = (pagination, filters, sorter) => {
    if (data?.kitegateway_reference) {
      const searchParams = [{ kitegateway_reference: { $regex: data.kitegateway_reference, $options: 'i' } }];
      dispatch(getTimeLines(generateQuery(pagination, filters, sorter, searchParams)));
    } else {
      dispatch(getTimeLines(generateQuery(pagination, filters, sorter)));
    }
  };

  const props = {
    pagination: {
      current: timeline_logs.page,
      pageSize: timeline_logs.pageSize,
      total: timeline_logs.pageTotal,
      showSizeChanger: false,
    },
    onRow: viewTransactionDetails,
    onChange: handleOnChange,
    loading: (timeline_logs.loading),
    columns,
    dataSource,
  };

  return data && data._id ? (
    <div>
      <div className="justify-content-center">
        <Card title={data.server_name}>
          <Descriptions>
            <Descriptions.Item label="Server Name">{data.server_name}</Descriptions.Item>
            <Descriptions.Item label="Kitegateway Reference">{`${data.kitegateway_reference}`}</Descriptions.Item>
            <Descriptions.Item label="Stage">{`${data.stage}`}</Descriptions.Item>
            <Descriptions.Item label="Status">{`${data.status}`}</Descriptions.Item>
            <Descriptions.Item label="Status Message">{`${data.status_message}`}</Descriptions.Item>
            <Descriptions.Item label="Callback URL">{`${data.callback_url}`}</Descriptions.Item>
            <Descriptions.Item label="Callback Payload" span={3}>
              <ReactJson src={data.callback_payload} collapsed />
            </Descriptions.Item>
            <Descriptions.Item label="Callback Response Code">{`${data.callback_response_code}`}</Descriptions.Item>
          </Descriptions>
        </Card>

        <Card title="Related timelines">
          <Table className="gx-table-responsive striped-table" {...props} />
        </Card>
      </div>

      <Modal
        visible={visibleTransactionModal && selectedRecord}
        okText="Close"
        confirmLoading={timeline_logs.loading}
        onCancel={handleModalCancelTransactionModal}
        onOk={handleModalCancelTransactionModal}
        footer=""
      >
        <TimelimeDetailsForModal {
          ...{ selectedRecord }}
        />
      </Modal>
    </div>
  ) : '';
};

export default TimelineDetails;
